import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { useAppSelector } from "../hook";
import {
  assetTreeSelectionReducers,
  AssetTreeSelectionState,
  criarEstadoDeSelecaoDaArvore,
} from "../assetTreeSelectionReducers";

export type AssetTreeProps = AssetTreeSelectionState & {
  selectedRegional: string[];
};

const initialState: AssetTreeProps = {
  selectedRegional: [],
  ...criarEstadoDeSelecaoDaArvore(),
};

export const VolksCustomAssetTreeSlice = createSlice({
  name: "volksAssetTree",
  initialState,
  reducers: {
    ...assetTreeSelectionReducers,
    setSelectedRegional: (state, action: PayloadAction<string[]>) => {
      state.selectedRegional = action.payload;
    },
  },
});

export const {
  setSelectedRegional,
  setSelectedCategories,
  setSelectedClients,
  setSelectedContracts,
  setSelectedVehicles,
} = VolksCustomAssetTreeSlice.actions;

export const getStoredSelectedRegional = (state: RootState) => state.volksCustomAssetTree.selectedRegional;
export const getStoredSelectedCategories = (state: RootState) => state.volksCustomAssetTree.selectedCategories;
export const getStoredSelectedClients = (state: RootState) => state.volksCustomAssetTree.selectedClients;
export const getStoredSelectedContracts = (state: RootState) => state.volksCustomAssetTree.selectedContracts;
export const getStoredSelectedVehicles = (state: RootState) => state.volksCustomAssetTree.selectedVehicles;

export const useGetStoredSelectedRegional = () => useAppSelector(getStoredSelectedRegional);
export const useGetStoredSelectedCategories = () => useAppSelector(getStoredSelectedCategories);
export const useGetStoredSelectedClients = () => useAppSelector(getStoredSelectedClients);
export const useGetStoredSelectedContracts = () => useAppSelector(getStoredSelectedContracts);
export const useGetStoredSelectedVehicles = () => useAppSelector(getStoredSelectedVehicles);

export default VolksCustomAssetTreeSlice.reducer;
